function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import { passwordValidation } from '@nordvpn/teams.core/lib/validation';
import { IsEqualTo } from '@nordvpn/teams.core/lib/validation/FormValidation';
import { hasLowercaseLetter, hasNumber, hasUppercaseLetter, maxLength, minLength } from '@nordvpn/teams.core/lib/validation/Validator';
var PW_FIELD = 'pw';
export var PasswordValidationMessage = /*#__PURE__*/ function (PasswordValidationMessage) {
    PasswordValidationMessage["NotEqual"] = "Passwords do not match, please check that you've entered and confirmed your new password correctly!";
    PasswordValidationMessage["LengthExceeded"] = "Password must be less than 72 characters long.";
    PasswordValidationMessage["NotSecure"] = "Password must be at least 12 characters long and include lowercase letters, uppercase letters, and numbers.";
    return PasswordValidationMessage;
}({});
export var isPasswordSecure = function isPasswordSecure(password) {
    return minLength(password, 12) && hasLowercaseLetter(password) && hasUppercaseLetter(password) && hasNumber(password);
};
export var passwordValidationV2 = function passwordValidationV2(password, fieldName) {
    var errors = {};
    if (!isPasswordSecure(password)) {
        errors[fieldName] = PasswordValidationMessage.NotSecure;
    }
    if (!maxLength(password, 72)) {
        errors[fieldName] = PasswordValidationMessage.LengthExceeded;
    }
    return _objectSpread({}, errors);
};
export var repeatedPasswordValidation = function repeatedPasswordValidation(password, confirmedPassword, fieldName) {
    var errors = _objectSpread({}, passwordValidationV2(confirmedPassword, fieldName));
    if (IsEqualTo(confirmedPassword, password)) {
        errors[fieldName] = PasswordValidationMessage.NotEqual;
    }
    return _objectSpread({}, errors);
};
/**
 * Wrapper around core password validator to just work with value and error.
 *
 * Returns error message if password not valid, undefined otherwise.
 */
export var validatePassword = function validatePassword(value) {
    return passwordValidation(value, PW_FIELD)[PW_FIELD] || undefined;
};
export var validatePasswordV2 = function validatePasswordV2(value) {
    return passwordValidationV2(value, PW_FIELD)[PW_FIELD] || undefined;
};
